module.exports = __webpack_public_path__ + "img/transparencia_four.cb714114.png";